import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NeoDialogModule, NeoDialogRef } from '@neogov/pattern-library/neo-dialog';
import { ButtonComponent, IconComponent } from '@presentation/components';

export type SessionExpiredModalResult = 'refresh' | 'go-home';

@Component({
  selector: 'cm-session-expired-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NeoDialogModule, ButtonComponent, IconComponent],
  templateUrl: './session-expired-modal.component.html',
  styleUrl: './session-expired-modal.component.less',
})
export class SessionExpiredModalComponent {
  private readonly _dialogRef = inject<NeoDialogRef<SessionExpiredModalComponent, SessionExpiredModalResult>>(NeoDialogRef);

  public onRefresh(): void {
    this._dialogRef.close('refresh');
  }

  public onGoHome(): void {
    this._dialogRef.close('go-home');
  }
}
